import moment from "moment";

import { emailPattern } from "./constants";

export const validation = {
  name: {
    isAllowedCharacters: (name) => /^[a-zA-Z, .'-]+$/.test(name?.trim()),
    hasAtleast2Characters: (name) => name?.trim()?.length >= 2,
    hasAtmost50Characters: (name) => name?.trim()?.length <= 50,
  },

  number: {
    isUSPhoneNumber: (usPhoneNumber) => /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/.test(usPhoneNumber),
    isANumber: (number) => /^\d+$/.test(number),
    is10DigitPhoneNumber: (phoneNumber) => {
      // Remove all non-numeric characters and check if exactly 10 digits
      const digitsOnly = phoneNumber?.replace(/\D/g, "") || "";
      return digitsOnly.length === 10;
    },
  },

  email: {
    isAValidEmail: (email) => emailPattern.test(email?.trim()),
    hasAtmost254Characters: (email) => email?.trim()?.length <= 254,
    isRandomEmail: (email) => email?.trim()?.startsWith("random-"),
  },

  address: {
    isAllowedCharacters: (address) => /^[a-zA-Z0-9, .'-@/#]+$/.test(address?.trim()),
  },

  streetAddress: {
    hasAtleast3Characters: (address) =>
      address?.trim()?.length >= 3 || "Your address must be at least 3 characters long",
  },

  aptSuiteUnit: {
    hasAtmost50Characters: (aptSuiteUnit) =>
      aptSuiteUnit?.trim()?.length <= 30 || "Your apt/suite number must not be longer than 30 characters",
  },

  city: {
    hasAtleast2Characters: (city) => city?.trim()?.length >= 2 || "Your city must be at least 2 characters long",
  },

  otp: { isValidOTP: (otp) => /^\d{6}$/.test(otp) },

  SSN: {
    isAValidSSN: (ssn) => /^\d{3} \d{2} \d{4}$/.test(ssn),
  },

  date: {
    isAValidDate: (date) =>
      (/^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/.test(date) && !isNaN(new Date(date))) ||
      "Please enter a valid date",
    isAbove18YearsOfAge: (date) => moment().diff(moment(date), "years") >= 18 || "You must be at least 18 years old",
  },

  zipcode: {
    is5DigitZipCode: (zipcode) => !zipcode || /^\d{5}$/.test(zipcode) || "Please enter a valid ZIP code",
  },

  bankRoutingNumber: {
    isValidRoutingNumber: (bankRoutingNumber) =>
      /^\d{9}$/.test(bankRoutingNumber) || "Routing number must be 9 digits long",
  },

  bankAccountNumber: {
    isValidAccountNumber: (bankAccountNumber) =>
      /^\d{1,20}$/.test(bankAccountNumber) || "Account number can't exceed 20 characters",
  },
};
